import http from "@/settings/apiSettings"

class ConBilanturiDataService{
  save(data: any): Promise<any> {
        return http.clientContabilitate.post("/CON_Bilanturi", data);
      }
  
}
export default new ConBilanturiDataService();